// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import OELeverageSelectorTemplate from '@front/templates/OELeverageSelectorTemplate.html';
import { ContainerControl } from '../../elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { OrderUtils } from '@shared/utils/Trading/OrderUtils';
import { ProductType } from '@shared/utils/Instruments/ProductType';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class OELeverageSelector extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'OELeverageSelector';
    }
    oninit() {
        super.oninit();
        this.observe('selectedItem', this.updateLeverageValue);
        this.observe('leverageValue', this.updateSelectedItemByLeverage);
        this.observe('instrument account productType', this.repopulate);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    localize() {
        void this.set('label', Resources.getResource('panel.newOrderEntry.Leverage'));
    }
    updateLeverageValue(selectedItem) {
        void this.set('leverageValue', selectedItem ? selectedItem.value : null);
    }
    updateSelectedItemByLeverage(leverage) {
        // need for CreateAlertPanel to change ComboBox selected item by custom leverageValue
        const currentSelectedItem = this.get('selectedItem');
        if (!isNullOrUndefined(currentSelectedItem) && currentSelectedItem.value !== leverage) {
            const items = this.get('items');
            for (let i = 0; i < items.length; i++) {
                if (items[i].value == leverage) {
                    void this.set('selectedItem', items[i]);
                    return;
                }
            }
        }
    }
    repopulate(newV, oldV) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!isNullOrUndefined(newV) && newV === oldV) {
                return;
            }
            const instrument = this.get('instrument');
            const account = this.get('account');
            const productType = this.get('productType') || ProductType.General;
            const dict = !isNullOrUndefined(instrument) ? instrument.getLeverages(account, productType) : null;
            if (isNullOrUndefined(instrument) ||
                isNullOrUndefined(account) ||
                !(dict === null || dict === void 0 ? void 0 : dict.length) ||
                !instrument.isHedgingNettingType()) {
                yield this.set({
                    leverageValue: null, // #113886
                    visible: false
                });
                return;
            }
            const items = dict.map(function (leverage) {
                return {
                    type: NewContextMenuItemType.Default,
                    value: leverage,
                    text: OrderUtils.GetFormattedLeverage(leverage)
                };
            });
            const visible = true; // (items[0].value == ProductType.General) ? false : true,           // при ProductType.General скрываем комбобокс
            const enabled = items.length !== 1; // при единственном ProductType делаем комбобокс enabled
            void this.set({
                items,
                selectedItem: items.length > 0 ? items[items.length - 1] : null,
                visible,
                enabled
            });
        });
    }
}
ContainerControl.extendWith(OELeverageSelector, {
    template: OELeverageSelectorTemplate,
    data: function () {
        return {
            label: '',
            instrument: null,
            account: null,
            items: null,
            selectedItem: null,
            leverageValue: null,
            productType: null,
            showLastValue: false,
            visible: false,
            enabled: true,
            showLabel: true,
            tooltip: 'OELeverageSelector.tooltip'
        };
    }
});
